<template>
    <div class="fullheight">
        <div class="fullheight">
            <AppAutoLogout ref="AppAutoLogout" />
            <AppHeader :rotate-icon="rotateIcon" @open="handleOpenSider" />
            <Row
                :wrap="false"
                class="app-content-wrapper"
                :class="{ 'is-mobile': isMobile, 'is-sider-open': isMobile && !isCollapsed }"
            >
                <Col flex="none" class="app-sider-col">
                    <AppSider
                        ref="AppSider"
                        :is-collapsed="isMobile ? false : isCollapsed"
                        :menuitem-classes="menuitemClasses"
                        @collapsed="handleSiderCollapsed"
                        @select="handleMenuSelect"
                    />
                </Col>
                <div v-if="isMobile && !isCollapsed" class="app-sider-backdrop" @click="isCollapsed = true"></div>
                <Col flex="auto" style="overflow: auto; overflow-x: hidden">
                    <Content class="app-content">
                        <router-view></router-view>
                    </Content>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
import AppSider from '@/components/Layouts/AppSider';
import AppHeader from '@/components/Layouts/AppHeader';
import AppAutoLogout from '@/components/Layouts/AppAutoLogout';

const MOBILE_BREAKPOINT = 767;

export default {
    components: {
        AppSider,
        AppHeader,
        AppAutoLogout,
    },
    data() {
        return {
            isMobile: window.innerWidth <= MOBILE_BREAKPOINT,
            isCollapsed: window.innerWidth <= MOBILE_BREAKPOINT,
        };
    },
    computed: {
        rotateIcon() {
            return ['menu-icon', this.isCollapsed ? 'rotate-icon' : ''];
        },
        menuitemClasses() {
            return ['menu-item', this.isCollapsed && !this.isMobile ? 'collapsed-menu' : ''];
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleOpenSider() {
            // On mobile the sider is a drawer: always rendered expanded, shown/hidden via isCollapsed
            if (this.isMobile) {
                this.isCollapsed = !this.isCollapsed;
                return;
            }
            this.$refs['AppSider'].toggleCollapse();
        },
        handleMenuSelect() {
            if (this.isMobile) this.isCollapsed = true;
        },
        handleResize() {
            const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
            if (isMobile === this.isMobile) return;
            this.isMobile = isMobile;
            // Start closed when entering mobile so the drawer doesn't cover the page
            if (isMobile) this.isCollapsed = true;
        },
        handleSiderCollapsed(val) {
            this.isCollapsed = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.app-content-wrapper {
    position: relative;
    height: calc(100% - 64px);
}
.app-sider-col {
    border-right: 1px solid #463c6e21;
}
.app-content {
    margin: 50px;
}
.app-content-wrapper.is-mobile {
    .app-sider-col {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 20;
        background: #fff;
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
        transform: translateX(-100%);
        visibility: hidden;
        transition: transform 0.2s ease, visibility 0.2s;
    }
    &.is-sider-open .app-sider-col {
        transform: translateX(0);
        visibility: visible;
    }
    .app-content {
        margin: 16px;
    }
}
.app-sider-backdrop {
    position: absolute;
    inset: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.35);
}
.layout-header-bar {
    background: #fff;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.layout-logo-left {
    width: 90%;
    height: 30px;
    background: #5b6270;
    border-radius: 3px;
    margin: 15px auto;
}
</style>
